import { IPopOutSpaceData } from 'js/bubbleCore/types';
import { ILevelData } from 'js/bubbleCore/levelParser/parseLevel';
import { convertHexLimitsToSpaceLimits } from 'js/bubbleCore/utils/convertHexLimitsToSpaceLimits';
import { convertRectangleToSpace } from 'js/bubbleCore/utils/convertRectangleToSpace';
import { getHexSize } from 'js/bubbleCore/utils/getHexSize';
import { generatePointZones } from 'js/bubbleCore/levelParser/generatePointZones';
import { generateBouncers } from 'js/bubbleCore/levelParser/generateBouncers';
import { RandomDataGenerator } from 'framework/RandomDataGenerator/RandomDataGenerator';

export function parsePopOutSpace(rnd: RandomDataGenerator, levelData: ILevelData): IPopOutSpaceData {
  const type = levelData.grid.type;
  const hexLimits = levelData.grid.hexLimits;
  const spaceLimits = convertRectangleToSpace(
    convertHexLimitsToSpaceLimits(hexLimits, type)
  );

  const hexSize = getHexSize(type);

  // to cover board edge to edge (as 0x0 is center of hex)
  const outerLimits = convertRectangleToSpace(
    convertHexLimitsToSpaceLimits({
      x: hexLimits.x - hexSize.width * 0.5,
      y: hexLimits.y - hexSize.height * 0.5,
      width: hexLimits.width + 1,
      height: hexLimits.height + 1,
    }, type)
  );

  const pointZones = generatePointZones(
    rnd,
    levelData.popOutSpace.pointZones,
    {
      left: outerLimits.left,
      right: outerLimits.right,
      top: levelData.popOutSpace.pointZonesY,
      bottom: levelData.popOutSpace.pointZonesY + 10,
    },
  );

  const bouncers = generateBouncers(
    rnd,
    levelData.popOutSpace.pointZones,
    levelData.popOutSpace.bouncers.width,
    {
      left: outerLimits.left,
      right: outerLimits.right,
      top: levelData.popOutSpace.bouncers.y,
      bottom: levelData.popOutSpace.bouncers.y + levelData.popOutSpace.bouncers.height,
    },
  );

  return {
    type,
    limits: spaceLimits,
    values: [],
    gravity: levelData.popOutSpace.gravity,
    popOutVelRange: levelData.popOutSpace.popOutVelRange,
    pointZones,
    bouncers,
  };
}